module.exports = __webpack_public_path__ + "img/balloons.b21ae1f3.png";